import React from 'react';
import { TrendingUp, Users, Landmark, ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { TRANSACTIONS, CHART_DATA } from '../../data/mockData';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
export function Overview() {
  const recentTx = TRANSACTIONS.slice(0, 5);
  return <div className="max-w-6xl mx-auto space-y-6" data-id="element-661">
      <div className="flex items-center justify-between" data-id="element-662">
        <h1 className="text-2xl font-semibold text-bone" data-id="element-663">Overview</h1>
        <div className="flex items-center gap-2 text-sm" data-id="element-664">
          <span className="text-muted" data-id="element-665">Last updated:</span>
          <span className="text-bone" data-id="element-666">Just now</span>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-667">
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-5" data-id="element-668">
          <div className="flex items-center justify-between mb-4" data-id="element-669">
            <div className="text-sm font-medium text-muted" data-id="element-670">
              Total Collected (Today)
            </div>
            <div className="w-8 h-8 rounded-lg bg-mint/10 text-mint flex items-center justify-center" data-id="element-671">
              <Landmark className="w-4 h-4" data-id="element-672" />
            </div>
          </div>
          <div className="text-3xl font-semibold text-bone mb-2" data-id="element-673">
            R 12,450.00
          </div>
          <div className="flex items-center gap-1 text-sm text-mint" data-id="element-674">
            <TrendingUp className="w-4 h-4" data-id="element-675" />
            <span data-id="element-676">+14.5% vs yesterday</span>
          </div>
        </div>

        <div className="bg-ink-2 border border-white/5 rounded-2xl p-5" data-id="element-677">
          <div className="flex items-center justify-between mb-4" data-id="element-678">
            <div className="text-sm font-medium text-muted" data-id="element-679">
              Active Accounts
            </div>
            <div className="w-8 h-8 rounded-lg bg-blue-500/10 text-blue-400 flex items-center justify-center" data-id="element-680">
              <Users className="w-4 h-4" data-id="element-681" />
            </div>
          </div>
          <div className="text-3xl font-semibold text-bone mb-2" data-id="element-682">8,412</div>
          <div className="flex items-center gap-1 text-sm text-mint" data-id="element-683">
            <ArrowUpRight className="w-4 h-4" data-id="element-684" />
            <span data-id="element-685">+124 this week</span>
          </div>
        </div>

        <div className="bg-ink-2 border border-white/5 rounded-2xl p-5" data-id="element-686">
          <div className="flex items-center justify-between mb-4" data-id="element-687">
            <div className="text-sm font-medium text-muted" data-id="element-688">
              Failed Collections
            </div>
            <div className="w-8 h-8 rounded-lg bg-red-500/10 text-red-400 flex items-center justify-center" data-id="element-689">
              <ArrowDownRight className="w-4 h-4" data-id="element-690" />
            </div>
          </div>
          <div className="text-3xl font-semibold text-bone mb-2" data-id="element-691">2.4%</div>
          <div className="flex items-center gap-1 text-sm text-mint" data-id="element-692">
            <ArrowDownRight className="w-4 h-4" data-id="element-693" />
            <span data-id="element-694">-0.8% vs last month</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-695">
        {/* Chart */}
        <div className="lg:col-span-2 bg-ink-2 border border-white/5 rounded-2xl p-5" data-id="element-696">
          <div className="flex items-center justify-between mb-6" data-id="element-697">
            <h2 className="text-lg font-semibold text-bone" data-id="element-698">
              Collection Volume
            </h2>
            <select className="bg-ink border border-white/10 rounded-lg px-3 py-1.5 text-sm text-bone focus:outline-none focus:border-mint" data-id="element-699">
              <option data-id="element-700">Last 7 days</option>
              <option data-id="element-701">Last 30 days</option>
            </select>
          </div>
          <div className="h-[300px] w-full" data-id="element-702">
            <ResponsiveContainer width="100%" height="100%" data-id="element-703">
              <AreaChart data={CHART_DATA} margin={{
              top: 10,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-704">
                
                <defs data-id="element-705">
                  <linearGradient id="colorUssd" x1="0" y1="0" x2="0" y2="1" data-id="element-706">
                    <stop offset="5%" stopColor="#2BE38C" stopOpacity={0.3} data-id="element-707" />
                    <stop offset="95%" stopColor="#2BE38C" stopOpacity={0} data-id="element-708" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#2E3033" vertical={false} data-id="element-709" />
                
                <XAxis dataKey="name" stroke="#8A8B8F" fontSize={12} tickLine={false} axisLine={false} data-id="element-710" />
                
                <YAxis stroke="#8A8B8F" fontSize={12} tickLine={false} axisLine={false} tickFormatter={value => `R${value / 1000}k`} data-id="element-711" />
                
                <Tooltip contentStyle={{
                backgroundColor: '#1A1B1D',
                borderColor: '#2E3033',
                borderRadius: '8px',
                color: '#E8E8EC'
              }} itemStyle={{
                color: '#2BE38C'
              }} data-id="element-712" />
                
                <Area type="monotone" dataKey="ussd" stroke="#2BE38C" strokeWidth={2} fillOpacity={1} fill="url(#colorUssd)" data-id="element-713" />
                
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-5 flex flex-col" data-id="element-714">
          <div className="flex items-center justify-between mb-6" data-id="element-715">
            <h2 className="text-lg font-semibold text-bone" data-id="element-716">Live Feed</h2>
            <button className="text-sm text-mint hover:text-mint-dim transition-colors" data-id="element-717">
              View all
            </button>
          </div>
          <div className="flex-1 space-y-4" data-id="element-718">
            {recentTx.map(tx => <div key={tx.id} className="flex items-center justify-between p-3 rounded-xl bg-ink border border-white/5" data-id="element-719">
              
                <div data-id="element-720">
                  <div className="text-sm font-medium text-bone" data-id="element-721">{tx.ref}</div>
                  <div className="text-xs text-muted mono" data-id="element-722">{tx.channel}</div>
                </div>
                <div className="text-right" data-id="element-723">
                  <div className="text-sm font-semibold text-bone" data-id="element-724">
                    R {tx.amount.toFixed(2)}
                  </div>
                  <div className="text-xs text-muted" data-id="element-725">
                    {new Date(tx.timestamp).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit'
                })}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}